// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-774dbe61] {\n  fill: #fff\n}\n.st102[data-v-774dbe61] {\n  fill: #ec65ba\n}\n", ""]);
// Exports
module.exports = exports;
